import { useQuery } from "@apollo/client";
import { gql } from "@apollo/client";

interface Role {
  id: string;
  roleName: string;
  roleId: string;
}

const GET_ALL_ROLES = gql`
  query getRoles {
    user {
      id
      account {
        id

        allRoleRates {
          id
          roleName
          roleId
        }
      }
    }
  }
`;

const GET_ROLES_BY_MEMBERS = gql`
  query getRolesByMembers($memberIds: [ID!]!) {
    user {
      id
      account {
        id

        roleRatesByMembers(memberIds: $memberIds) {
          id
          roleName
          roleId
        }
      }
    }
  }
`;

type UseRolesProps = {
  memberIds?: string[];
};

const useRoles = ({ memberIds }: UseRolesProps = {}) => {
  const shouldFilterByMembers = memberIds && memberIds.length > 0;

  const { data: allRolesData } = useQuery(GET_ALL_ROLES, {
    skip: shouldFilterByMembers
  });

  const { data: filteredRolesData } = useQuery(GET_ROLES_BY_MEMBERS, {
    variables: { memberIds },
    skip: !shouldFilterByMembers
  });

  const roles: Role[] = shouldFilterByMembers
    ? filteredRolesData?.user?.account?.roleRatesByMembers || []
    : allRolesData?.user?.account?.allRoleRates || [];

  return { roles: roles.map(role => ({ ...role, name: role.roleName })) };
};

export default useRoles;
